import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  & > * + * {
    margin-inline-start: 10px !important;
  }
`;

export const DropdonwWrapper = styled.div`
  width: 260px;
`;

export const SearchBarWrapper = styled.div`
  position: relative;
`;

export const SearchBar = styled.input`
  width: 100%;
  height: 36px;
  width: 260px;
  padding: 8px 36px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey002};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const SearchBarIcon = styled.i`
  position: absolute;
  top: 9px;
  left: 13px;
  font-style: normal;
  color: ${({ theme }) => theme.colors.grey002};

  &:before {
    content: '\\e905';
    font-family: 'Icomoon';
  }
`;
